import { ThemeOptions } from "@mui/material";

import components from "./components";
import palette from "./palette";
import shadows from "./shadows";
import shape from "./shape";
import typography from "./typography";

const themeOptions: ThemeOptions = {
  palette,
  shadows,
  typography,
  shape,
  components,
};

export default themeOptions;
